import { makeInstaller } from './utils/make-installer';
import Components from './component';

export default makeInstaller([...Components]);
